export const isStrongCustomerPassword = password => typeof password === 'string' && password.length >= 8 && password.length <= 200 && /[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password) && /[^A-Za-z0-9]/.test(password);

export const customerDisplayName = value => /^user$/i.test(String(value || '').trim()) ? '' : String(value || '');

// Use the displayed customer name for both the label and avatar on every page.
export const customerIdentity = (user = {}, profile = {}) => {
  const name = customerDisplayName(profile?.name).trim() || customerDisplayName(user?.name).trim();
  const email = String(profile?.email || user?.email || '').trim();
  const fallback = /@placeholder\.local$/i.test(email) ? '' : email;
  return { name: name || 'Customer', initial: Array.from(name || fallback || 'C')[0].toLocaleUpperCase() };
};
